import { gql } from '@apollo/client';

export const SAVE_ACTIVATION = gql`
  mutation SaveActivation(
    $audienceId: ID!
    $audienceName: String!
    $destinationPartnerId: ID!
    $destinationPartnerName: String!
    $percentSelected: Float!
    $recordsIncluded: Int!
    $processingId: String!
    $s3Config: S3ConfigInput
    $sftpConfig: SftpConfigInput
  ) {
    saveActivation(
      audienceId: $audienceId
      audienceName: $audienceName
      destinationPartnerId: $destinationPartnerId
      destinationPartnerName: $destinationPartnerName
      percentSelected: $percentSelected
      recordsIncluded: $recordsIncluded
      processingId: $processingId
      s3Config: $s3Config
      sftpConfig: $sftpConfig
    ) {
      id
      recordsIncluded
      startedAt
      audienceName
      destinationPartner {
        id
        slug
        name
        displayName
      }
    }
  }
`;
